import React from "react";
import { Link } from "react-router-dom";
import TableColumnAction from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "Project ID",
        render: (item) => (
            <span>
                <Link to={`/sp-projects/${item}`}>#{item}</Link>
            </span>
        ),
        sortable: true,
    },
    {
        field: "name",
        name: "Project Name",
        sortable: false,
    },
    {
        field: "clientName",
        name: "Client Name",
        sortable: false,
    },
    {
        field: "supplierName ",
        name: "Supplier Name ",
        sortable: false,
    },
    {
        field: "createdAt",
        name: "Creation Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "startDate",
        name: "Started At",
        dataType: "date",
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: "Creator Email",
        sortable: false,
    },

    {
        name: "Actions",
        isActionsPopover: true,
        actions: TableColumnAction(actions),
    },
];

export default columns;
